module.exports = __webpack_public_path__ + "static/media/Quiz.998d67cc.svg";